import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSection } from 'ui/components'

import { HistoryProps } from './History.types'

import { s } from './styles'

const routeApi = getRouteApi('/_app/application/$applicationId/onboarding-documents/$id/details')

export const History = ({ history, historyTotalCount }: HistoryProps) => {
  const navigate = routeApi.useNavigate()
  const { historySize, historyPage } = routeApi.useSearch()

  return (
    <s.HistorySection>
      <PageSection title="History" anchor="history">
        <Layer rounded shadowed stretch={false}>
          <HistoryTable
            dataQa={TableDataQa.BP_ONBOARDING_DOCUMENTS_HISTORY}
            loading={false}
            items={history}
            pagination={{
              page: historyPage,
              size: historySize,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              onChange: (page, size) => navigate({ search: { page, size }, resetScroll: false, replace: false }),
              total: historyTotalCount
            }}
          />
        </Layer>
      </PageSection>
    </s.HistorySection>
  )
}
